import { Vector3 } from 'three/src/math/Vector3';

export default new Map([
  [1, [new Vector3(0.0, 10.0, -50.0)]],
  [2, [new Vector3(6.0, 10.0, -50.0), new Vector3(-6.0, 10.0, -54.0)]],
  [
    3,
    [
      new Vector3(0.0, 10.0, -50.0),
      new Vector3(-12.0, 10.0, -54.0),
      new Vector3(12.0, 10.0, -54.0)
    ]
  ],
  [
    4,
    [
      new Vector3(-6.0, 10.0, -50.0),
      new Vector3(-15.0, 10.0, -54.0),
      new Vector3(6.0, 10.0, -54.0),
      new Vector3(15.0, 10.0, -50.0)
    ]
  ],
  [
    5,
    [
      new Vector3(-6.0, 2.5, -50.0),
      new Vector3(-15.0, 2.5, -54.0),
      new Vector3(6.0, 2.5, -54.0),
      new Vector3(15.0, 2.5, -50.0),
      new Vector3(1.0, 22.5, -60.0)
    ]
  ],
  [
    6,
    [
      new Vector3(-6.0, 2.5, -50.0),
      new Vector3(-15.0, 2.5, -54.0),
      new Vector3(6.0, 2.5, -54.0),
      new Vector3(15.0, 2.5, -50.0),
      new Vector3(-7.5, 22.5, -62.0),
      new Vector3(2.5, 22.5, -60.0)
    ]
  ],
  [
    7,
    [
      new Vector3(-6.0, 2.5, -50.0),
      new Vector3(-15.0, 2.5, -54.0),
      new Vector3(6.0, 2.5, -54.0),
      new Vector3(15.0, 2.5, -50.0),
      new Vector3(-10.0, 22.5, -60.0),
      new Vector3(10.0, 22.5, -60.0),
      new Vector3(0.0, 22.5, -62.0)
    ]
  ],
  [
    8,
    [
      new Vector3(-6.0, 2.5, -50.0),
      new Vector3(-15.0, 2.5, -54.0),
      new Vector3(6.0, 2.5, -54.0),
      new Vector3(15.0, 2.5, -50.0),
      new Vector3(-15.0, 22.5, -60.0),
      new Vector3(15.0, 22.5, -62.0),
      new Vector3(5.0, 22.5, -60.0),
      new Vector3(-5.0, 22.5, -62.0)
    ]
  ]
]);
